// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tree-view-chart-sec {
    height: calc(100% - 263px);
    overflow: auto;
}

.grabbable {
    cursor: move;
    cursor: grab;
    cursor: -webkit-grab;
}

.grabbable:active {
    cursor: grabbing;
    cursor: -webkit-grabbing;
}

.select-option1 {
    position: relative;
    -webkit-user-select: none;
            user-select: none;
}

.treeContainer {
    width: 100%;
    overflow: auto;
}

.url{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.preview-image-none {
    font-size: 22px;
    background: #e1e1e1;
    height: 300px !important;
    display: flex;
    align-items: center;
    justify-content: center;
}

.preview-image {
    width: 100%;
    height: auto;
    max-height: 300px;
    cursor: pointer;
    object-fit: contain;
}

.tree-Modal .tree-card-vid .leave-btn,
.tree-Modal .tree-card-vid .more-btn {
    position: absolute;
    top: 8px;
    z-index: 99;
}

.tree-Modal .tree-card-vid .leave-btn {
    left: 14px;
    color: #ffffff;
    opacity: 1;
    font-weight: 400;
    font-size: 16px;
}

.tree-Modal .tree-card-vid .more-btn {
    right: 8px;
}

.tree-Modal .tree-card-content .check-line span {
    width: 20px;
    height: 20px;
    border: 1px solid black;
    display: inline-block;
    margin-right: 8px;
}

.tree-Modal .tree-card-content .check-line input {
    color: #000;
    margin-left: 10px;
    border: 0px;
    width: 6vw;
    border-bottom: 1px solid #ccc;
    font: 400 14px/20px Roboto, "Helvetica Neue", sans-serif;
}

.tree-Modal .tree-card-content .check-line label {
    cursor: pointer;
    font-size: 15px;
}

.tree-Modal .tree-card-content .check-line input:checked+label:after {
    content: "";
    position: absolute;
    left: 22px;
    top: 5px;
    width: 6px;
    height: 14px;
    border: solid #6e5eff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

textarea::-webkit-scrollbar {
    width: 6px;
}

textarea::-webkit-scrollbar-track {
    background: transparent;
}

textarea::-webkit-scrollbar-thumb {
    background: #ebebed;
    border-radius: 50px;
}

textarea::-webkit-scrollbar-thumb:hover {
    background: #d9d9db;
}

.close {
    font-weight: normal !important;
}

input.close.leave-btn {
    background: transparent;
    border: none;
    padding-bottom: 5px;
    border-bottom: 1px solid #ccc;
    text-align: center;
    width: 100%;
    margin-left: 0px;
}

.title-center {
    float: none;
    margin-left: 90px;
}

.tree-card-vid {
    position: relative;
}

.add-choices input {
    width: 60px;
    display: inline-block;
}

.choice-btn {
    border: 1px solid #6e5eff;
    padding: 5px 15px;
    border-radius: 5px;
    background: #6e5eff;
    color: #ffff;
    display: inline-block;
    cursor: pointer;
    position: relative;
    outline: none;
    border-left: 0;
    height: -moz-fit-content;
    height: fit-content;
    margin: 15px;
}

.chexk-box-top {
    width: 100%;
    margin: 5px;
}

.dropdownWidth {
    padding-right: 4px !important;
    padding-left: 4px !important;
}

.option-choices {
    margin-bottom: 15px;
}

.option-choices.draggable {
    cursor: move;
    border: 1px dashed #dc3545;
}

.nodeTitleInput {
    background: transparent;
    border: none;
    border-bottom: 1px solid transparent;
    outline: none;
    padding-bottom: 5px;
    width: 100%;
}

.nodeTitleInput:focus {
    border-bottom: 1px solid #ccc;
}

.w-qus {
    width: 3.2rem;
    height: 3.2rem;
}

.cursor {
    cursor: pointer;
}

.timer-button {
    background: #6e5eff;
    border-color: #6e5eff;
    color: white;
    padding: 8px 10px;
    border-radius: 5px;
    cursor: pointer;
}

.create-interactive-button {
    border: 1px solid #6e5eff;
    padding: 8px 30px;
    border-radius: 5px;
    background: #6e5eff;
    color: #ffff;
    font-size: 15px;
    display: block;
    cursor: pointer;
    position: relative;
    outline: none;
    margin: 4px 0 4px 4px;
}

.civ-paths-btn {
    display: inline-flex;
    align-items: center;
    background: rgba(100, 56, 180, 0.05);
    border: 1px solid #6438B4;
    border-radius: 50px;
    font-weight: 500;
    font-size: 14px;
    color: #6438B4;
    padding: 0 16px;
    margin: 5px;
    min-height: 50px;
    position: relative;
}

.civ-paths-btn i {
    display: none;
    cursor: pointer;
    margin-right: -5px;
    margin-left: 5px;
}

.civ-paths-btn:hover i {
    display: inline-block;
}

.objective-img {
    height: 48px;
    display: flex;
    align-items: center;
    width: -moz-fit-content;
    width: fit-content;
}

.popup-objective {
    z-index: 1;
    position: absolute;
    background: white;
    padding: 0 7px;
    border-radius: 6px;
    width: -moz-fit-content;
    width: fit-content;
    top: 52px;
    right: 0;
    width: 200px;
    height: 210px;
    overflow: auto;
}

.popup-objective ul {
    text-align: start;
    padding-left: 25px;
}

.popup-objective li {
    margin-top: 10px;
}

.civ-zoom-btn {
    box-shadow: none;
    border: none;
    background: #6e5eff;
    color: #fff;
    border-radius: 5px;
    font-size: 16px;
    padding: 5px 13px;
    margin: 5px;
}

.topBottomBtn {
    position: fixed;
    bottom: 98px;
    right: 0;
    z-index: 12;
    background-color: black;
    color: white;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    font-size: 14px;
    text-align: center;
}

.btn {
    outline: none;
    box-shadow: none;
}

.fa-external-link-alt {
    text-align: center;
    position: absolute;
    top: 41%;
    left: 48%;
    height: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    display: block;
}

.footer-title-input {
    border-top: none;
    border-left: none;
    border-radius: 0;
    border-right: none;
    background-color: transparent;
    color: #ffffff;
}

.footer-title-input:focus {
    background-color: transparent;
    color: #ffffff;
}

.add-pathways-container {
    height: 82%;
    width: 460px;
    position: fixed;
    z-index: 99;
    top: 70px;
    right: 5px;
}

.add-pathways-container .path-img {
    border-radius: 13px;
    max-height: 250px;
    width: 100%;
}

.civ-message-body {
    display: flex;
}

.civ-message-body.from {
    justify-content: flex-start;
}

.civ-message-body.to {
    justify-content: flex-end;
}

.civ-message {
    display: inline-block;
    border-radius: 1.5rem;
    margin-bottom: 15px;
    padding: 8px 20px;
    position: relative;
}

.civ-message-body.to .civ-message {
    background-color: #9b4dca;
    color: #fff;
    margin-left: 100px;
    width: 200px;
}

.civ-message-body.from .civ-message {
    background-color: #E5E4E9;
    color: #363636;
    margin-right: 100px;
}

.civ-message-body.to+.civ-message-body.to,
.civ-message-body.from+.civ-message-body.from {
    margin-top: -10px;
}

.civ-message .msg-description {
    overflow-wrap: anywhere;
}

.objectImg img {
    height: 40px;
}

.objectImg span i {
    font-size: 18px;
    cursor: pointer;
    color: #6c6c6c;
}

.civ-message .type-image {
    width: 100px;
}

.objectives {
    width: 300px;
    position: relative;
    margin: 11px 0 0 0;
}

.objectives input {
    margin: 0px;
    padding: 0px;
    width: 100%;
    outline: none;
    height: 40px;
    border-radius: 5px;
    border: none;
    padding: 0 0 0 5px;
}

.objectives button {
    position: absolute;
    top: 0;
    right: -2px;
    z-index: 2;
    border: none;
    top: 0;
    height: 40px;
    cursor: pointer;
    transform: translateX(2px);
    width: 36px;
}

.objectives i {
    font-size: 18px;
    line-height: 2;
    color: #6c6c6c;
}

.show-objectives {
    width: 100%;
    height: 40px;
    position: relative;
    margin: 11px 0 0 0;
    background-color: white;
    color: #6c6c6c;
    overflow-wrap: anywhere;
    overflow: auto;
    padding: 0 5px;
}

.objectivesButtons .btnDone {
    background: #9b4dca;
    color: white;
    padding: 0 5px;
    font-size: 15px;
}

.objectivesButtons .btnCancel {
    background: #6c6c6c;
    color: white;
    padding: 0 5px;
    font-size: 15px;
}

.example-full-width {
    width: 100%;
}

.pathways-colors {
    margin: 0px 5px 10px;
    width: 60px;
    height: 30px;
    border-radius: 10px;
}

.civ-message-suggestion {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 5px;
}

.civ-message-suggestion .list-group-item {
    padding: 0.5rem;
}

.civ-message-suggestion .choice {
    cursor: pointer;
    padding: 4px 10px;
    color: #6e5eff;
    border: 1px solid #6e5eff;
    border-radius: 2rem;
    font-weight: 500;
}

.tree-share-Modal,
.tree-preview-vid-Modal,
.tree-publish-vid-Modal {
    padding-left: 15px !important;
    padding-right: 15px !important;
}

.tree-share-Modal .modal-body,
.tree-share-Modal .modal-header,
.tree-preview-vid-Modal .modal-body,
.tree-preview-vid-Modal .modal-header,
.tree-publish-vid-Modal .modal-body,
.tree-publish-vid-Modal .modal-header {
    padding: 20px 25px 25px 25px;
}

.tree-share-Modal .modal-title,
.tree-preview-vid-Modal .modal-title,
.tree-publish-vid-Modal .modal-title {
    font-size: 18px;
    font-weight: 600;
}

.civr-tab {
    width: 100%;

}

.civr-tab .nav-tabs {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    border: none;
}

.civr-tab .nav-tabs .nav-link {
    border: none;
    background: transparent;
    list-style: none;
    font-weight: 500;
    font-size: 18px;
    padding: 5px 0;
    margin: 0px 25px;
    color: #878395;
    cursor: pointer;
}

.civr-tab .nav-tabs .nav-link svg {
    fill: #878395;
}

.civr-tab .nav-tabs .nav-link.active {
    border-top: 3px solid #6c2fbb;
    color: #6c2fbb;
}

.civr-tab .nav-tabs .nav-link.active svg {
    fill: rgba(108, 47, 187, 1);
}


.civr-tab .pro-img {
    width: 50px;
    height: 50px;
    border-radius: 10px;
}

.civr-tab .profile-image {
    width: 50px;
    height: 50px;
    font-size: 22px;
    line-height: 30px;
    border-radius: 10px;
}

.civr-tab .civr-username {
    margin: 10px;
}

.civr-tab .civr-checkbox {
    display: flex !important;
    align-items: center;
    line-height: 0px;
}

.FF-scroll-modify {
    max-height: 360px;
    height: auto;
    overflow-x: hidden;
    overflow-y: scroll;
}

.sharing-modal-body {
    padding: 15px;
}

.collabeBody {
    height: 325px !important;
    overflow-x: hidden;
    overflow-y: scroll;
}

.sharing-links {
    list-style-type: none;
    padding: 0;
    text-align: center;
    margin-bottom: 40px;
}

.sharing-links li {
    display: inline-block;
    margin-right: 40px;
    cursor: pointer;
}

.sharing-links li img {
    width: 50px;
    height: 50px;
}

.sharing-links li p {
    font-size: 12px;
    color: #a6a3a3;
}

.user-list-item {
    width: 100%;
    text-align: left;
    margin-right: 30px;
}

.follower-name {
    margin-left: 10px;
}

.collabeImg {
    border-radius: 7px;
    width: 30px !important;
    height: 30px !important;
    margin-right: 4px;
    margin-top: -7px;
}

.tree-preview-vid-Modal .preview-vid .vid-txt .vid-title h5 {
    font-size: 17px;
    margin-bottom: 0px;
    margin-top: 1rem;
}

.tree-preview-vid-Modal .preview-vid .vid-txt>.row {
    align-items: center;
}

.tree-preview-vid-Modal .preview-vid .vid-txt .vid-btn button {
    font-size: 15px;
    color: black;
    padding: 8px 0px;
    border-radius: 6px;
    transition: all 0.2s linear;
    width: 150px;
    border: 1px solid #ccc;
}

.tree-preview-vid-Modal .preview-vid .vid-txt .vid-btn button:hover {
    background-color: #6e5eff;
    color: #ffffff;
}

.optionsOFchoice {
    background: #000;
    z-index: 9;
    position: relative;
    display: table;
    width: 100%;
    text-align: center;
}

.optionschoiceitem {
    padding: 20px 10px;
    font-size: 16px;
    color: #fff;
    box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.5);
    cursor: pointer;
    border-right: 1px solid #fff;
    display: table-cell;
    word-break: break-all;
}

.optionschoiceitem:hover {
    color: #726bfa;
}

@media (max-width: 991px) {
    .tree-view-chart-sec {
        padding: 0px 26px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/createInteractiveVideo/ai-video-creator/ai-video-creator.component.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IAEZ,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAEhB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,UAAU;IACV,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,6BAA6B;IAC7B,wDAAwD;AAC5D;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,wBAAmB;IAAnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,oCAAoC;IACpC,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,QAAQ;IACR,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,UAAU;IACV,YAAY;IACZ,MAAM;IACN,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,uBAAuB;IACvB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;;IAGI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;;;;;;IAMI,4BAA4B;AAChC;;AAEA;;;IAGI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,8CAA8C;IAC9C,eAAe;IACf,4BAA4B;IAC5B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ","sourcesContent":[".tree-view-chart-sec {\n    height: calc(100% - 263px);\n    overflow: auto;\n}\n\n.grabbable {\n    cursor: move;\n    cursor: grab;\n    cursor: -moz-grab;\n    cursor: -webkit-grab;\n}\n\n.grabbable:active {\n    cursor: grabbing;\n    cursor: -moz-grabbing;\n    cursor: -webkit-grabbing;\n}\n\n.select-option1 {\n    position: relative;\n    user-select: none;\n}\n\n.treeContainer {\n    width: 100%;\n    overflow: auto;\n}\n\n.url{\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\n.preview-image-none {\n    font-size: 22px;\n    background: #e1e1e1;\n    height: 300px !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.preview-image {\n    width: 100%;\n    height: auto;\n    max-height: 300px;\n    cursor: pointer;\n    object-fit: contain;\n}\n\n.tree-Modal .tree-card-vid .leave-btn,\n.tree-Modal .tree-card-vid .more-btn {\n    position: absolute;\n    top: 8px;\n    z-index: 99;\n}\n\n.tree-Modal .tree-card-vid .leave-btn {\n    left: 14px;\n    color: #ffffff;\n    opacity: 1;\n    font-weight: 400;\n    font-size: 16px;\n}\n\n.tree-Modal .tree-card-vid .more-btn {\n    right: 8px;\n}\n\n.tree-Modal .tree-card-content .check-line span {\n    width: 20px;\n    height: 20px;\n    border: 1px solid black;\n    display: inline-block;\n    margin-right: 8px;\n}\n\n.tree-Modal .tree-card-content .check-line input {\n    color: #000;\n    margin-left: 10px;\n    border: 0px;\n    width: 6vw;\n    border-bottom: 1px solid #ccc;\n    font: 400 14px/20px Roboto, \"Helvetica Neue\", sans-serif;\n}\n\n.tree-Modal .tree-card-content .check-line label {\n    cursor: pointer;\n    font-size: 15px;\n}\n\n.tree-Modal .tree-card-content .check-line input:checked+label:after {\n    content: \"\";\n    position: absolute;\n    left: 22px;\n    top: 5px;\n    width: 6px;\n    height: 14px;\n    border: solid #6e5eff;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n}\n\ntextarea::-webkit-scrollbar {\n    width: 6px;\n}\n\ntextarea::-webkit-scrollbar-track {\n    background: transparent;\n}\n\ntextarea::-webkit-scrollbar-thumb {\n    background: #ebebed;\n    border-radius: 50px;\n}\n\ntextarea::-webkit-scrollbar-thumb:hover {\n    background: #d9d9db;\n}\n\n.close {\n    font-weight: normal !important;\n}\n\ninput.close.leave-btn {\n    background: transparent;\n    border: none;\n    padding-bottom: 5px;\n    border-bottom: 1px solid #ccc;\n    text-align: center;\n    width: 100%;\n    margin-left: 0px;\n}\n\n.title-center {\n    float: none;\n    margin-left: 90px;\n}\n\n.tree-card-vid {\n    position: relative;\n}\n\n.add-choices input {\n    width: 60px;\n    display: inline-block;\n}\n\n.choice-btn {\n    border: 1px solid #6e5eff;\n    padding: 5px 15px;\n    border-radius: 5px;\n    background: #6e5eff;\n    color: #ffff;\n    display: inline-block;\n    cursor: pointer;\n    position: relative;\n    outline: none;\n    border-left: 0;\n    height: fit-content;\n    margin: 15px;\n}\n\n.chexk-box-top {\n    width: 100%;\n    margin: 5px;\n}\n\n.dropdownWidth {\n    padding-right: 4px !important;\n    padding-left: 4px !important;\n}\n\n.option-choices {\n    margin-bottom: 15px;\n}\n\n.option-choices.draggable {\n    cursor: move;\n    border: 1px dashed #dc3545;\n}\n\n.nodeTitleInput {\n    background: transparent;\n    border: none;\n    border-bottom: 1px solid transparent;\n    outline: none;\n    padding-bottom: 5px;\n    width: 100%;\n}\n\n.nodeTitleInput:focus {\n    border-bottom: 1px solid #ccc;\n}\n\n.w-qus {\n    width: 3.2rem;\n    height: 3.2rem;\n}\n\n.cursor {\n    cursor: pointer;\n}\n\n.timer-button {\n    background: #6e5eff;\n    border-color: #6e5eff;\n    color: white;\n    padding: 8px 10px;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.create-interactive-button {\n    border: 1px solid #6e5eff;\n    padding: 8px 30px;\n    border-radius: 5px;\n    background: #6e5eff;\n    color: #ffff;\n    font-size: 15px;\n    display: block;\n    cursor: pointer;\n    position: relative;\n    outline: none;\n    margin: 4px 0 4px 4px;\n}\n\n.civ-paths-btn {\n    display: inline-flex;\n    align-items: center;\n    background: rgba(100, 56, 180, 0.05);\n    border: 1px solid #6438B4;\n    border-radius: 50px;\n    font-weight: 500;\n    font-size: 14px;\n    color: #6438B4;\n    padding: 0 16px;\n    margin: 5px;\n    min-height: 50px;\n    position: relative;\n}\n\n.civ-paths-btn i {\n    display: none;\n    cursor: pointer;\n    margin-right: -5px;\n    margin-left: 5px;\n}\n\n.civ-paths-btn:hover i {\n    display: inline-block;\n}\n\n.objective-img {\n    height: 48px;\n    display: flex;\n    align-items: center;\n    width: fit-content;\n}\n\n.popup-objective {\n    z-index: 1;\n    position: absolute;\n    background: white;\n    padding: 0 7px;\n    border-radius: 6px;\n    width: fit-content;\n    top: 52px;\n    right: 0;\n    width: 200px;\n    height: 210px;\n    overflow: auto;\n}\n\n.popup-objective ul {\n    text-align: start;\n    padding-left: 25px;\n}\n\n.popup-objective li {\n    margin-top: 10px;\n}\n\n.civ-zoom-btn {\n    box-shadow: none;\n    border: none;\n    background: #6e5eff;\n    color: #fff;\n    border-radius: 5px;\n    font-size: 16px;\n    padding: 5px 13px;\n    margin: 5px;\n}\n\n.topBottomBtn {\n    position: fixed;\n    bottom: 98px;\n    right: 0;\n    z-index: 12;\n    background-color: black;\n    color: white;\n    border-radius: 50%;\n    width: 35px;\n    height: 35px;\n    font-size: 14px;\n    text-align: center;\n}\n\n.btn {\n    outline: none;\n    box-shadow: none;\n}\n\n.fa-external-link-alt {\n    text-align: center;\n    position: absolute;\n    top: 41%;\n    left: 48%;\n    height: 50%;\n    transform: translate(-50%, -50%);\n    width: 10px;\n    height: 10px;\n    display: block;\n}\n\n.footer-title-input {\n    border-top: none;\n    border-left: none;\n    border-radius: 0;\n    border-right: none;\n    background-color: transparent;\n    color: #ffffff;\n}\n\n.footer-title-input:focus {\n    background-color: transparent;\n    color: #ffffff;\n}\n\n.add-pathways-container {\n    height: 82%;\n    width: 460px;\n    position: fixed;\n    z-index: 99;\n    top: 70px;\n    right: 5px;\n}\n\n.add-pathways-container .path-img {\n    border-radius: 13px;\n    max-height: 250px;\n    width: 100%;\n}\n\n.civ-message-body {\n    display: flex;\n}\n\n.civ-message-body.from {\n    justify-content: flex-start;\n}\n\n.civ-message-body.to {\n    justify-content: flex-end;\n}\n\n.civ-message {\n    display: inline-block;\n    border-radius: 1.5rem;\n    margin-bottom: 15px;\n    padding: 8px 20px;\n    position: relative;\n}\n\n.civ-message-body.to .civ-message {\n    background-color: #9b4dca;\n    color: #fff;\n    margin-left: 100px;\n    width: 200px;\n}\n\n.civ-message-body.from .civ-message {\n    background-color: #E5E4E9;\n    color: #363636;\n    margin-right: 100px;\n}\n\n.civ-message-body.to+.civ-message-body.to,\n.civ-message-body.from+.civ-message-body.from {\n    margin-top: -10px;\n}\n\n.civ-message .msg-description {\n    overflow-wrap: anywhere;\n}\n\n.objectImg img {\n    height: 40px;\n}\n\n.objectImg span i {\n    font-size: 18px;\n    cursor: pointer;\n    color: #6c6c6c;\n}\n\n.civ-message .type-image {\n    width: 100px;\n}\n\n.objectives {\n    width: 300px;\n    position: relative;\n    margin: 11px 0 0 0;\n}\n\n.objectives input {\n    margin: 0px;\n    padding: 0px;\n    width: 100%;\n    outline: none;\n    height: 40px;\n    border-radius: 5px;\n    border: none;\n    padding: 0 0 0 5px;\n}\n\n.objectives button {\n    position: absolute;\n    top: 0;\n    right: -2px;\n    z-index: 2;\n    border: none;\n    top: 0;\n    height: 40px;\n    cursor: pointer;\n    transform: translateX(2px);\n    width: 36px;\n}\n\n.objectives i {\n    font-size: 18px;\n    line-height: 2;\n    color: #6c6c6c;\n}\n\n.show-objectives {\n    width: 100%;\n    height: 40px;\n    position: relative;\n    margin: 11px 0 0 0;\n    background-color: white;\n    color: #6c6c6c;\n    overflow-wrap: anywhere;\n    overflow: auto;\n    padding: 0 5px;\n}\n\n.objectivesButtons .btnDone {\n    background: #9b4dca;\n    color: white;\n    padding: 0 5px;\n    font-size: 15px;\n}\n\n.objectivesButtons .btnCancel {\n    background: #6c6c6c;\n    color: white;\n    padding: 0 5px;\n    font-size: 15px;\n}\n\n.example-full-width {\n    width: 100%;\n}\n\n.pathways-colors {\n    margin: 0px 5px 10px;\n    width: 60px;\n    height: 30px;\n    border-radius: 10px;\n}\n\n.civ-message-suggestion {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 5px;\n}\n\n.civ-message-suggestion .list-group-item {\n    padding: 0.5rem;\n}\n\n.civ-message-suggestion .choice {\n    cursor: pointer;\n    padding: 4px 10px;\n    color: #6e5eff;\n    border: 1px solid #6e5eff;\n    border-radius: 2rem;\n    font-weight: 500;\n}\n\n.tree-share-Modal,\n.tree-preview-vid-Modal,\n.tree-publish-vid-Modal {\n    padding-left: 15px !important;\n    padding-right: 15px !important;\n}\n\n.tree-share-Modal .modal-body,\n.tree-share-Modal .modal-header,\n.tree-preview-vid-Modal .modal-body,\n.tree-preview-vid-Modal .modal-header,\n.tree-publish-vid-Modal .modal-body,\n.tree-publish-vid-Modal .modal-header {\n    padding: 20px 25px 25px 25px;\n}\n\n.tree-share-Modal .modal-title,\n.tree-preview-vid-Modal .modal-title,\n.tree-publish-vid-Modal .modal-title {\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.civr-tab {\n    width: 100%;\n\n}\n\n.civr-tab .nav-tabs {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    border: none;\n}\n\n.civr-tab .nav-tabs .nav-link {\n    border: none;\n    background: transparent;\n    list-style: none;\n    font-weight: 500;\n    font-size: 18px;\n    padding: 5px 0;\n    margin: 0px 25px;\n    color: #878395;\n    cursor: pointer;\n}\n\n.civr-tab .nav-tabs .nav-link svg {\n    fill: #878395;\n}\n\n.civr-tab .nav-tabs .nav-link.active {\n    border-top: 3px solid #6c2fbb;\n    color: #6c2fbb;\n}\n\n.civr-tab .nav-tabs .nav-link.active svg {\n    fill: rgba(108, 47, 187, 1);\n}\n\n\n.civr-tab .pro-img {\n    width: 50px;\n    height: 50px;\n    border-radius: 10px;\n}\n\n.civr-tab .profile-image {\n    width: 50px;\n    height: 50px;\n    font-size: 22px;\n    line-height: 30px;\n    border-radius: 10px;\n}\n\n.civr-tab .civr-username {\n    margin: 10px;\n}\n\n.civr-tab .civr-checkbox {\n    display: flex !important;\n    align-items: center;\n    line-height: 0px;\n}\n\n.FF-scroll-modify {\n    max-height: 360px;\n    height: auto;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n.sharing-modal-body {\n    padding: 15px;\n}\n\n.collabeBody {\n    height: 325px !important;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n.sharing-links {\n    list-style-type: none;\n    padding: 0;\n    text-align: center;\n    margin-bottom: 40px;\n}\n\n.sharing-links li {\n    display: inline-block;\n    margin-right: 40px;\n    cursor: pointer;\n}\n\n.sharing-links li img {\n    width: 50px;\n    height: 50px;\n}\n\n.sharing-links li p {\n    font-size: 12px;\n    color: #a6a3a3;\n}\n\n.user-list-item {\n    width: 100%;\n    text-align: left;\n    margin-right: 30px;\n}\n\n.follower-name {\n    margin-left: 10px;\n}\n\n.collabeImg {\n    border-radius: 7px;\n    width: 30px !important;\n    height: 30px !important;\n    margin-right: 4px;\n    margin-top: -7px;\n}\n\n.tree-preview-vid-Modal .preview-vid .vid-txt .vid-title h5 {\n    font-size: 17px;\n    margin-bottom: 0px;\n    margin-top: 1rem;\n}\n\n.tree-preview-vid-Modal .preview-vid .vid-txt>.row {\n    align-items: center;\n}\n\n.tree-preview-vid-Modal .preview-vid .vid-txt .vid-btn button {\n    font-size: 15px;\n    color: black;\n    padding: 8px 0px;\n    border-radius: 6px;\n    transition: all 0.2s linear;\n    width: 150px;\n    border: 1px solid #ccc;\n}\n\n.tree-preview-vid-Modal .preview-vid .vid-txt .vid-btn button:hover {\n    background-color: #6e5eff;\n    color: #ffffff;\n}\n\n.optionsOFchoice {\n    background: #000;\n    z-index: 9;\n    position: relative;\n    display: table;\n    width: 100%;\n    text-align: center;\n}\n\n.optionschoiceitem {\n    padding: 20px 10px;\n    font-size: 16px;\n    color: #fff;\n    box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.5);\n    cursor: pointer;\n    border-right: 1px solid #fff;\n    display: table-cell;\n    word-break: break-all;\n}\n\n.optionschoiceitem:hover {\n    color: #726bfa;\n}\n\n@media (max-width: 991px) {\n    .tree-view-chart-sec {\n        padding: 0px 26px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
